/**
 * Translated copy for `FileDropzone` from `@sentricmusic/ui`, which ships English
 * defaults. Spread the result onto every dropzone in the dashboard so the
 * prompt, buttons and format caption follow the user's language.
 */

import type { FileDropzoneProps } from "@sentricmusic/ui";

import { useTranslation } from "react-i18next";

type FileDropzoneLabels = Pick<FileDropzoneProps, "prompt" | "selectLabel" | "selectAnotherLabel" | "clearLabel" | "formatsLabel">;

export function useFileDropzoneLabels(): FileDropzoneLabels {
  const { t } = useTranslation();

  return {
    prompt: String(t("common:file-dropzone-prompt", "Drag and drop a file here")),
    selectLabel: String(t("common:file-dropzone-select-file", "Select file")),
    selectAnotherLabel: String(t("common:file-dropzone-select-another-file", "Select another file")),
    clearLabel: String(t("common:file-dropzone-clear-selected-file", "Clear selected file")),
    formatsLabel: String(t("common:file-dropzone-supported-format", "Supported format")),
  };
}
